(() => {
  if (window.rhdHubspotNewsletterInit) return;
  window.rhdHubspotNewsletterInit = true;

  const formId = "0e5081c5-59f1-42b0-8d83-589ad6954c31";
  const portalId = "145851647";
  const scriptSrc = `https://js-eu1.hsforms.net/forms/embed/developer/${portalId}.js`;
  const formSelector = `.hs-form-html[data-form-id="${formId}"]`;

  const ensureHubSpotScript = () => {
    if (!document.querySelector(formSelector)) return;

    const hasScript = Array.from(document.scripts).some((script) => script.src === scriptSrc);
    if (hasScript) return;

    const script = document.createElement("script");
    script.src = scriptSrc;
    script.defer = true;
    document.head.appendChild(script);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureHubSpotScript, { once: true });
  } else {
    ensureHubSpotScript();
  }
})();
